import { createFileRoute } from "@tanstack/react-router";

import { AGererPage } from "@/features/a-gerer/AGererPage";

export const Route = createFileRoute("/_connecte/a-gerer")({
  component: AGererPage,
});
